<div class="p8_page-block__container">
  <div class="p8_page-block__header-container">
    <ng-content select=".p8-page-block-header"></ng-content>
  </div>
  <div class="p8_page-block__content">
    <ng-content select=".p8-page-block-content"></ng-content>
  </div>
</div>
